// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileFilledSvg from "@fishx/icons-svg/es/asn/ProfileFilled";
import FishxIcon from '../components/FishxIcon';

var ProfileFilled = function ProfileFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProfileFilledSvg
  }));
};

ProfileFilled.displayName = 'ProfileFilled';
export default React.forwardRef(ProfileFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ProfileFilled.js
// module id = 3850
// module chunks = 0